// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"364":"ff4f6a1c","750":"f95713d5"}[chunkId] + ".js";
};